export default "__VITE_ASSET__CHiRGjMK__"